export interface NavLinkItem {
  label: string;
  to: string;
  icon: string;
}

export const navLinks: NavLinkItem[] = [
  { label: "首页", to: "/", icon: "ri-home-5-line" },
  { label: "法律法规", to: "/category/laws", icon: "ri-scales-3-line" },
  { label: "伦理道德", to: "/category/ethics", icon: "ri-lightbulb-flash-line" },
  { label: "案例分析", to: "/category/cases", icon: "ri-folders-line" },
  { label: "关于", to: "/about", icon: "ri-information-line" },
];

export const popularTags: string[] = [
  "禁婚亲属",
  "未成年人保护",
  "知情同意",
  "婚姻效力",
  "伤害原则",
  "证据规则",
  "公共秩序",
];